import { Button } from '@simplywallst/ui-core/next';
import PlusIcon from '@simplywallst/ui-core/icons/PlusSolid';
import StarIcon from '@simplywallst/ui-core/icons/StarOutline';

export const ActionButtonGroup = () => {
  // TODO: Connect component up to data
  return (
    <div className="@container/abg">
      <div className="grid select-none gap-2 @[375px]:grid-cols-2 @[425px]:max-w-max @[500px]:grid-flow-col @[500px]:grid-cols-none [&_button]:h-x4 [&_button]:gap-px [&_button]:whitespace-nowrap [&_button_svg]:h-5 [&_button_svg]:w-auto [&_button_svg]:shrink-0">
        <Button size="large" variant="primary">
          <PlusIcon /> Add to Portfolio
        </Button>
        <div className="grid w-full grid-flow-col gap-2">
          <Button size="large" variant="outline">
            <StarIcon /> Watch
          </Button>
          <Button
            size="large"
            variant="outline"
            className="hidden @[500px]:block"
          >
            Add note
          </Button>
          <Button
            size="large"
            variant="outline"
            className="hidden @[500px]:block"
          >
            Compare
          </Button>
          <Button size="large" variant="outline">
            <span className="sr-only">More actions</span>
            <span className="-mt-2.5 text-xl font-bold" aria-hidden="true">
              &hellip;
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

/* For reference

import WatchlistHeaderActions from '@/pages/CompanyReport/components/WatchlistHeaderActions';
import { useDownloadCSV, useSummary } from '@/hooks/useCompany';
import { useUser } from '@/hooks/useUser';
import { useUserAccess } from '@/hooks/useUserAccess';

const summary = useSummary();
const user = useUser();
const { data: userAccess } = useUserAccess();
const downloadCSV = useDownloadCSV(
  summary.canonicalUrl,
  summary.status === 'success' ? summary.uniqueSymbol : undefined
);

if (summary.status === 'loading') return;

return (
  <WatchlistHeaderActions
    companyId={summary.companyId}
    canonicalUrl={summary.canonicalUrl}
    uniqueSymbol={summary.uniqueSymbol}
    tickerSymbol={summary.tickerSymbol}
    isUserLoggedIn={user.data.loggedIn}
    canGetReportPdf={userAccess.canGetCompanyReportPdf}
    canGetReportCsv={userAccess.canGetCompanyReportCsv}
    canGetShareLink={userAccess.canDistributeCompanyReportPdf}
    onFetchCompanyCsvReport={() => downloadCSV?.mutate()}
  />
);

*/
